import { render, staticRenderFns } from "./DialogChangeContactPerson.vue?vue&type=template&id=2ebd2045&scoped=true"
import script from "./DialogChangeContactPerson.vue?vue&type=script&lang=js"
export * from "./DialogChangeContactPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd2045",
  null
  
)

export default component.exports